import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { FixedDataService } from 'src/app/services/fixed-data.service';
import { UserData } from 'src/app/interfaces/userInfo.interface';
import { Plants } from 'src/app/shared/dto/plants';
import { Plant } from 'src/app/interfaces/plant.interface';
import { SessionData } from 'src/app/shared/localstorage/sessionData';
import { SearchInspectionScheduleService } from 'src/app/services/search-inspection-schedule.service';

@Component({
  selector: 'app-template-general',
  templateUrl: './template-general.component.html',
  styleUrls: ['./template-general.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('toggleBox', [
      // ...
      state('open', style({
        height: '*',
      })),
      state('closed', style({
        height: '0px',
      })),
      transition('open => closed', [
        animate('.3s')
      ]),
      transition('closed => open', [
        animate('.3s')
      ]),
    ])
  ]
})

export class TemplateGeneralComponent implements OnInit {

  user!: UserData;
  selected?: Plants;

  isOtherOpenAdmin = true;
  plants: Plant[] = [];

  // To open and close sidenav
  public isMenuOpen: boolean = false;

  public onSidenavClick(): void {
    this.isMenuOpen = false;
  }

  // Mostrar / Ocultar información
  isOpen = true;
  isOpenNewInspections = true;
  isOpenAdmin = true;
  isAdmin = false;

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private translate: TranslateService,
    private searchInspectionScheduleService: SearchInspectionScheduleService,
    private fixedData: FixedDataService) {
    translate.addLangs(['en', 'es']);
  }

  miFormulario: FormGroup = this.fb.group({
    languageControl: ['en'],
    selectedPlant: []
  });

  ngOnInit(): void {
    //inicializamos las variables con la informacion almacenada
    this.plants = this.fixedData.plants;
    this.user = SessionData.getCurrentUser();
    this.isAdmin = SessionData.getCurrentUser().admin;

    const language = SessionData.getLanguage();
    this.translate.use(language);

    //Seteamos el valor y nos suscribimos a los cambios de cada campo
    this.miFormulario.get('languageControl')?.setValue(language);
    this.miFormulario.get('selectedPlant')?.setValue(this.user.plant);
    this.miFormulario.get('languageControl')?.valueChanges
      .subscribe(valor => {
        SessionData.saveLanguage(valor);
        this.translate.use(valor);
        //TODO validar si se debe utilizar el location.reload()
        //El reload es necesario para conservar el lenguaje o planta seleccionada
        location.reload();
      });
    this.miFormulario.get('selectedPlant')?.valueChanges
      .subscribe((plant: Plants) => {
        /*this.user.plantId = plant.plantId;
        SessionData.updateSessionUser(this.user);*/
        location.reload();
      })
  }


  goToInspectionScheduller() {
    this.searchInspectionScheduleService.setMode("");
    this.searchInspectionScheduleService.setEvent("");
    this.searchInspectionScheduleService.fillFrequeciesList([]);
  }

  openOtherAdmin() {
    this.isOtherOpenAdmin = !this.isOtherOpenAdmin;
  }

  openSubAdmin() {
    this.isOpenAdmin = !this.isOpenAdmin;
  }

  verSub() {
    this.isOpen = !this.isOpen;
  }

  verNewInspections() {
    this.isOpenNewInspections = !this.isOpenNewInspections;
  }

  verSubAdmin() {
    this.isOpenAdmin = !this.isOpenAdmin;
  }

  logout() {
    this.authService.doLogout()
  }

}
